import axios from 'axios';

const saveUser = async (body, list) => {
  const { data } = await axios.post(`/api/saveUser?list=${list}`, body);
  return data;
};

const saveResponses = async (data, list) => {
  await axios.post(`/api/saveResponses?list=${list}`, { data });
};

const getResponses = async (list) => {
  const {
    data: { value },
  } = await axios.get(`/api/getResponses?listName=${list}`);
  return value;
};

const getDeadline = async () => {
  const { data } = await axios.get(`/api/deadline`);
  return data;
};

export const CommonService = {
  saveUser,
  getResponses,
  saveResponses,
  getDeadline,
};
